import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { XToggle } from '@swordhealth/ui'


export default /*@__PURE__*/_defineComponent({
  __name: 'SwordToggle',
  props: {
    value: { type: Boolean }
  },
  emits: ["input"],
  setup(__props: any, { emit: __emit }) {

/**
 * Bridge component: Vue 2 v-model (value/input) -> XToggle (modelValue/update:modelValue)
 *
 * Required while using @vue/compat in MODE: 2.
 * Once compat is removed or MODE is set to 3 globally, delete this file
 * and map SwordToggle directly to XToggle in global-components.ts
 */


const emit = __emit

const handleUpdate = (newValue: boolean) => {
  emit('input', newValue)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(XToggle), _mergeProps(_ctx.$attrs, {
    "model-value": __props.value,
    "onUpdate:modelValue": handleUpdate
  }), null, 16, ["model-value"]))
}
}

})